document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.mobile-menu li.menu-item-has-children > a');

    menuItems.forEach(function(item) {
        item.addEventListener('click', function(event) {
            event.preventDefault();

            const parent = this.parentElement;

            // Toggle active class for the clicked item
            parent.classList.toggle('active');

            // Remove active class from siblings
            const siblings = Array.from(parent.parentElement.children).filter(function(sibling) {
                return sibling !== parent;
            });

            siblings.forEach(function(sibling) {
                sibling.classList.remove('active');
            });
        });
    });
});

